@if (faelle().length === 0) {
  <div class="pe-detail__list">
    <div class="pe-case pe-case--empty">{{ 'testResults.plaene.noCases' | translate }}</div>
  </div>
} @else {
  <div class="pf-filter" role="group" [attr.aria-label]="'testResults.plaene.filter.ariaLabel' | translate">
    <span class="pf-filter__label">{{ 'testResults.plaene.filter.label' | translate }}</span>
    <button
      type="button"
      class="pf-chip pf-chip--alle"
      data-testid="plan-chip-alle"
      [attr.aria-pressed]="keineAuswahl()"
      (click)="zeigeAlle()"
    >
      {{ 'testResults.plaene.filter.alle' | translate }}
      <span class="pf-chip__count">{{ faelle().length }}</span>
    </button>
    @for (c of chips(); track c.status) {
      <button
        type="button"
        class="pf-chip"
        [attr.data-status]="c.status"
        [attr.data-testid]="'plan-chip-' + c.status"
        [attr.aria-pressed]="c.aktiv"
        [disabled]="c.anzahl === 0"
        (click)="toggle(c.status)"
      >
        @if (c.aktiv) {
          <mat-icon class="pf-chip__check" aria-hidden="true">check</mat-icon>
        } @else {
          <span class="pf-chip__dot" aria-hidden="true"></span>
        }
        {{ c.labelKey | translate }}
        <span class="pf-chip__count">{{ c.anzahl }}</span>
      </button>
    }
    @if (!keineAuswahl()) {
      <span class="pf-filter__summe" data-testid="plan-chip-summe">
        {{ 'testResults.plaene.filter.summe' | translate: { shown: sichtbar().length, total: faelle().length } }}
      </span>
    }
  </div>

  <div class="pe-detail__list" role="table" [attr.aria-label]="'testResults.plaene.cases.label' | translate">
    <div class="pf-table__head" role="row">
      <span role="columnheader">{{ 'testResults.plaene.cases.id' | translate }}</span>
      <span role="columnheader">{{ 'testResults.plaene.cases.testfall' | translate }}</span>
      <span role="columnheader">{{ 'testResults.plaene.cases.abweichung' | translate }}</span>
      <span role="columnheader">{{ 'testResults.plaene.cases.testlauf' | translate }}</span>
      <span role="columnheader">{{ 'testResults.plaene.cases.ergebnis' | translate }}</span>
    </div>
    <div class="pf-table__body" role="rowgroup">
      @for (f of sichtbar(); track f.testCaseId) {
        @let result = caseResult(f.status);
        @let link = executionsLink(f);
        <div class="pe-case" role="row" data-testid="plan-case-row" [class.pe-case--link]="link">
          <span role="cell">
            @if (f.testCaseKey) {
              <code class="pe-case__id">{{ f.testCaseKey }}</code>
            }
          </span>
          <span class="pe-case__testfall" role="cell" data-col="testfall">
            <span class="pe-case__title">
              @if (link) {
                <a class="pe-case__link" data-testid="plan-case-link" [routerLink]="link.commands">{{ f.titel }}</a>
              } @else {
                {{ f.titel }}
              }
            </span>
            @if (f.defects.length > 0) {
              <app-defect-ref-chips class="pe-case__defects" [projectId]="projectId()" [defects]="f.defects" />
            }
          </span>
          <span role="cell" data-col="abweichung">
            @if (f.bugKey) {
              <span class="pe-case__bug" [attr.title]="'testResults.plaene.bugTitle' | translate">{{ f.bugKey }}</span>
            } @else {
              <span class="pe-case__none">—</span>
            }
          </span>
          <span class="pe-case__lauf" role="cell">{{ f.laufKey || '—' }}</span>
          <span role="cell">
            <app-res-pill size="sm" [status]="result.pill" [label]="result.labelKey | translate" />
          </span>
        </div>
      }
    </div>
  </div>
}
